import { Map, List, fromJS } from 'immutable'
import { compose } from 'recompose'
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { connect as languageConnect } from '../Language/connect'
import { FILTER_SET_DEFAULT } from '../../services/filter-set/index'
import { getPrimary } from '../../services/languages/index'
import FiltersV2Set from './Filters.v2Set'
import FiltersV2Clear from './Filter.v2Clear'

function FiltersV2 ({
  filterSetType,
  setEventDefault,
  getFilterSetData,
  staticText,
  defaultSort,
  filterSet = Map(),
  location,
  language,
  history,
  tiles,
  auth,
}) {
  /**
   * A list of options selected by default
   * Only 'sort' is available for now
   */
  const defaultOptions = useMemo(() => fromJS({
    sort: defaultSort,
  }), [defaultSort])

  return (
    <div className="filters-v2">
      <div className="filters-v2__wrapper">
        <div>
          {/* render content filters */}
          {filterSetType !== FILTER_SET_DEFAULT
            ? <FiltersV2Set
              auth={auth}
              history={history}
              location={location}
              language={language}
              staticText={staticText}
              filterSet={filterSet}
              filterSetType={filterSetType}
              getFilterSetData={getFilterSetData}
              setEventDefault={setEventDefault}
              defaultOptions={defaultOptions}
            />
            : null
          }
        </div>
        <div>
          {/* render sort by */}
          <FiltersV2Set
            auth={auth}
            history={history}
            location={location}
            language={language}
            staticText={staticText}
            filterSet={filterSet}
            filterSetType={FILTER_SET_DEFAULT}
            getFilterSetData={getFilterSetData}
            setEventDefault={setEventDefault}
            defaultOptions={defaultOptions}
          />
        </div>
      </div>
      <FiltersV2Clear
        tiles={tiles}
        auth={auth}
        history={history}
        location={location}
        language={language}
        staticText={staticText}
        filterSetType={filterSetType}
      />
    </div>
  )
}

FiltersV2.propTypes = {
  filterSetType: PropTypes.string.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  tiles: ImmutablePropTypes.map.isRequired,
  language: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSet: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  getFilterSetData: PropTypes.func.isRequired,
  setEventDefault: PropTypes.func.isRequired,
  defaultSort: PropTypes.string,
}

export default compose(
  connectRedux(({
    staticText,
    filterSet,
    tiles,
    auth,
    user,
  }) => ({
    staticText: staticText.getIn(['data', 'filtersV2', 'data'], Map()),
    filterSet,
    tiles,
    auth,
    user,
    language: getPrimary(user.getIn(['data', 'language'], List())),
  }), (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      getFilterSetData: actions.filterSet.getFilterSetData,
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  }),
  languageConnect({ createOnLanguageChange: (actions) => actions.filterSet.resetFilterSetData }),
)(FiltersV2)
